import { Factory } from 'miragejs';

export default Factory.extend({
  type: 'predefined',
  id: 'settlement_date_local',
  label: 'Settlement date (local)',
});
